export const POST_AUTH_LANDING_PATH = '/analytics';
